import { useEffect } from "react";
import { useAuthStore } from "@";
import { useUserPermissionsQuery } from "@/shared/hooks/queries/useUserPermissionsQuery.jsx";

// Owns the user-permissions query and writes results back into the auth store
// so all existing consumers (useUserPermissions, useCanShow, CanShow) stay in sync.
// Mount once at the top of the authenticated tree (AuthLayout).
export const usePermissionsSync = () => {
  const { data } = useUserPermissionsQuery();
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);

  useEffect(() => {
    if (!data || !user) return;
    if (user.userPermissions === data) return;
    setUser({ ...user, userPermissions: data });
  }, [data, user, setUser]);
};
